import { ReactNode, type FC } from 'react';
import { X } from 'lucide';

// MUI
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// common
import Icon from 'common/components/Icon';
import IconButtonTooltip from 'common/components/IconButtonTooltip';

interface DialogWrapperProps {
  open: boolean;
  onClose: () => void;
  title: JSX.Element;
  children: ReactNode;
}

const DialogWrapper: FC<DialogWrapperProps> = (props) => {
  const { open, onClose, title, children } = props;

  return (
    <Dialog
      open={open}
      onClose={() => onClose()}
      aria-describedby="alert-dialog-slide-description"
      maxWidth={false} // Disable MUI's default maxWidth constraints
      sx={{
        '& .MuiDialog-paper': {
          maxWidth: '60dvw',
          width: '100%',
          margin: '32px',
        },
      }}
    >
      <DialogTitle>
        <Box>
          <Box sx={{ display: 'flex', justifyContent: 'end' }}>
            <IconButtonTooltip
              aria-label="Đóng"
              tooltipProps={{ title: 'Đóng' }}
              onClick={() => onClose()}
            >
              <Icon icon={X} />
            </IconButtonTooltip>
          </Box>
          <Typography variant="h6" component="div">
            {title}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ width: '100%' }}>
          <Box sx={{ width: '100%', borderTop: '1px dashed red', mb: 1 }} />
          {children}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default DialogWrapper;
